import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ParkerService } from '../services/parker.service';
import { ToastService } from '@shared/services/toast.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-remove-paker-confirm-modal',
  templateUrl: './remove-paker-confirm-modal.component.html',
  styleUrls: ['./remove-paker-confirm-modal.component.scss']
})
export class RemovePakerConfirmModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  addedParkerIdForGroupOperator: string = '';
  message: string = '';

  constructor(
    private readonly parkerService: ParkerService,
    private readonly toastService: ToastService,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,

  ) {

  }

  ngOnInit(): void {
    this.addedParkerIdForGroupOperator = this.config?.data?.id;
    this.message = this.config?.data?.message;
  }

  onConfirm() {
    this.parkerService.deleteGroupUserDriverById(this.addedParkerIdForGroupOperator,true).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response) => {
        const successMessage = response?.message;
        this.toastService.showToastMessage('success', 'Success', successMessage);
        
        this.ref.close({status: true});

      }, error: (error) => {
        const errorMessage = error?.error?.message;
        this.toastService.showToastMessage('error', 'Error', errorMessage);
        
      }
    })
  }

  onCancel() {
    this.ref.close({status: true});
  }

}
